var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "worker-risk",
      on: {
        click: function($event) {
          $event.stopPropagation()
        },
        dblclick: function($event) {
          $event.stopPropagation()
        }
      }
    },
    [
      _c("span", { class: ["custom-tag", _vm.variant] }, [
        _vm._v(_vm._s(_vm.label))
      ]),
      _vm._v(" "),
      _vm.isSmz
        ? _c(
            "button",
            {
              staticClass: "risk-help ml-1",
              attrs: {
                id: _vm.tooltipId,
                type: "button",
                "aria-label": "Описание рисков исполнителя"
              }
            },
            [_vm._v("?")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isSmz
        ? _c(
            "b-tooltip",
            {
              attrs: {
                target: _vm.tooltipId,
                noninteractive: "",
                triggers: "hover focus",
                placement: "auto"
              }
            },
            _vm._l(_vm.descriptions, function(description, index) {
              return _c("div", { key: index, staticClass: "text-left mb-1" }, [
                _vm._v(_vm._s(description))
              ])
            }),
            0
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9b2d5052", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b2d5052","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Workers/WorkerRisk.vue
// module id = null
// module chunks = 